module.exports = __webpack_public_path__ + "static/media/proj20_img2.b85117e5.jpg";